import { useState, useEffect } from 'react';
import { useI18n } from '../../../i18n';
import { Ic, ICON_PATHS } from '../../../lib/ui';
import { QuickSearchModal } from './QuickSearchModal';
import { LanguageSelector } from './LanguageSelector';

const HEADER_BG = '#0E243E';

interface AppHeaderProps {
  titulo?: string;
  modulo?: string;
  subtitulo?: string;
  gradient?: string;
  labels?: { key: string; value: string | number }[];
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export function AppHeader({ titulo, children }: AppHeaderProps) {
  const { t } = useI18n();
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen((prev) => !prev);
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      <header
        style={{
          padding: '0 32px',
          height: 48,
          minHeight: 48,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: HEADER_BG,
          color: '#fff',
          flexShrink: 0,
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }}
      >
        {/* Title */}
        <h1
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            letterSpacing: -0.2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: 1,
            minWidth: 0,
          }}
        >
          {titulo || 'V·IANet Governance'}
        </h1>

        {/* Right controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {/* Search */}
          <div
            onClick={() => setSearchOpen(true)}
            title={t.search.searchTooltip}
            style={{
              cursor: 'pointer',
              padding: 6,
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.1)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.background = 'transparent';
            }}
          >
            <Ic d={ICON_PATHS.search} s={18} c="rgba(255,255,255,0.6)" />
          </div>

          {/* Language */}
          <LanguageSelector />

          {/* Avatar */}
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 700,
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            AG
          </div>
        </div>

        {children}
      </header>

      {searchOpen && <QuickSearchModal onClose={() => setSearchOpen(false)} />}
    </>
  );
}
